import clsx from 'clsx';
import {FieldValues} from 'react-hook-form';

import {useAppForm} from '@/providers/components/formProvider';

import Button from '@/components/Button';

type FormSubmitButtonPropsT = {
  formId: string;
  className?: string;
  showStepCount?: boolean;
  label?: string;
  tabIndex?: number;
};

function FormSubmitButton({
  formId,
  className,
  showStepCount = true,
  label = 'Submit',
  tabIndex,
}: FormSubmitButtonPropsT) {
  const {
    state: {steps, step, loading},
    goToStep,
  } = useAppForm<FieldValues>({formId, enabled: true});

  if (!steps?.length) return null;

  return (
    <div className={clsx('flex flex-col gap-2', className)}>
      <div className="flex justify-around gap-4">
        {step > 0 && (
          <Button onClick={() => goToStep(step - 1)} color="info" width="full" tabIndex={tabIndex}>
            Back
          </Button>
        )}
        {step < steps.length - 1 && (
          <Button onClick={() => goToStep(step + 1)} color="primary" width="full" tabIndex={tabIndex}>
            Next
          </Button>
        )}
        {step >= steps.length - 1 && (
          <Button type="submit" width="full" tabIndex={tabIndex} loadingText="Loading..." isLoading={loading}>
            {label}
          </Button>
        )}
      </div>
      {showStepCount && (
        <p className="mt-2 text-center text-xs text-gray-500 underline underline-offset-[6px]">
          Step {step + 1} of {steps.length}
        </p>
      )}
    </div>
  );
}

export default FormSubmitButton;
